<template>
  <div id="box">
    <HeaderView></HeaderView>

    <img
      src="/img/news/images/xinwen-banner.jpg"
      alt=""
      class="responsive-img1"
    />
    <section class="section1">
      <div class="swiper-container">
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next" style="background: #e60013;"></div>
        <Swiper
          v-if="swiperList.length"
          :slides-per-view="1"
          :space-between="70"
          :loop="true"
          :autoplay="{ delay: 5000, disableOnInteraction: false }"
          :modules="modules"
          :navigation="{
            prevEl: '.swiper-button-prev',
            nextEl: '.swiper-button-next',
          }"
          class="swiper"
        >
          <SwiperSlide
            v-for="(item, idx) in swiperList"
            :key="idx"
            class="swiper-slide"
          >
            <div class="left-text">
              <h2 class="news-title" v-html="item.titile"></h2>
              <p>{{ item.brief }}</p>
              <div class="news-meta">
                <span><img class="date-icon" src="/img/news/images/date_03.png" alt="" />{{ item.create_time }}</span>
                <span><img class="date-icon" src="/img/news/images/date_03.png" alt="" />{{ item.num }}</span>
              </div>
            </div>
            <img :src="item.image" alt="" class="responsive-img" />
          </SwiperSlide>
        </Swiper>
      </div>

      <div class="tab-nav">
        <div
          v-for="(tab, idx) in tabs"
          :key="idx"
          :class="['tab-item', { active: activeTab === idx }]"
          @click="activeTab = idx"
        >
          {{ tab.label }}
        </div>
      </div>

      <div class="tab-content">
        <div
          v-for="(group, idx) in filteredNews"
          v-show="activeTab === idx"
          :key="idx"
          class="tab-pane"
        >
          <div
            v-for="(item, i) in group.slice(0, limits[idx])"
            :key="i"
            class="tab-pane-content"
            @click="goToDetail(item.id)"
          >
            <img :src="item.image" alt="" class="tab-pane-content-img"/>
            <div class="tab-pane-content-text">
              <h3>{{ item.titile }}</h3>
              <div class="news-meta">
                <span><img class="date-icon" src="/img/news/images/date_03.png" alt="" />{{ item.create_time }}</span>
                <span><img class="date-icon" src="/img/news/images/date_03.png" alt="" />{{ item.num }}</span>
              </div>
            </div>
          </div>
          <div
            v-show="limits[idx] < group.length"
            class="show-more"
            @click="toggleMore(idx)"
          >
            加载更多
          </div>
        </div>
      </div>
    </section>

    <FooterView></FooterView>
  </div>
</template>

<script>
import apiServe from "../services/index.js";
import HeaderView from "../components/HeaderView2.vue";
  import FooterView from '../components/FooterView.vue'
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
export default {
  components: {
    HeaderView,
    Swiper,
    SwiperSlide,
    FooterView
  },
  data() {
    return {
      swiperList: [],
      modules: [Pagination, Autoplay, Navigation],
      activeTab: 0,
      tabs: [],
      newsList: [],
      limits: [],
      copywriting: {},

    };
  },
  created() {},
  computed: {
    filteredNews() {
      // 如果还没有 tabs，返回空数组
      if (!this.tabs.length) return [];
      // 返回二维数组，每个子数组用对应 category_id 过滤
      return this.tabs.map(tab =>
        this.newsList.filter(item => item.category_id === tab.category_id)
      );
    }
  },
  mounted() {
    this.fetchProductData();
  },
  methods: {
    fetchProductData() {
      let data = {};
      apiServe.getNewlistData(data, 'get').then((res) => {
        console.log(res, "我是查询接口返回的数据");
        // 用接口返回的 category 列表生成 tabs
        this.tabs = (res.data.category || []).map(cat => ({
          label: cat.name,
          category_id: cat.id
        }));
        // 初始化对应数量的 limits
        this.limits = new Array(this.tabs.length).fill(9);
        this.newsList = res.data.news || [];
        // 轮播图数据：取 tnews 中 is_switch=1 的条目
        this.swiperList = (res.data.tnews || []).filter(item => item.is_switch == 1);
      });
      apiServe.getCopyWriting({}, "get").then((res) => {
        this.copywriting = res.data;
      })
    },
    toggleMore(idx) {
      // 只扩展当前点击的 tab 对应的 limits
      this.limits.splice(idx, 1, this.limits[idx] + 9);
    },
    goToDetail(id) {
      this.$router.push('/news/' + 'id=' + id);

    }
  },
  metaInfo() {
    return {
      title: this.copywriting?.title,
      meta: [
        { name: 'keywords', content: this.copywriting?.keywords },
        { name: 'description', content: this.copywriting?.description}
      ]
    };
  }
};
</script>

<style scoped>
.tab-pane-content-img {
  max-width:406px;
  width: 100%;
  max-height:304px;
  height: auto;
  border-radius: 15px;
  /* width: 100%;
  height: auto; */
}

.tab-pane-content {
  width: 28.5%;
  background-color: #f6f6f6;
  padding: 0.6rem;
  border-radius: 5px;
  margin-bottom: 2rem;
  border: 1px solid transparent;
  transition: all .3s ease;
}
.tab-pane-content-text {
  padding: 0 2rem;
  height: 123px;
  margin-top: 1.5rem;
}
.tab-pane-content-text h3 {
  min-height: 4rem;
/* 
  margin-bottom: 2.5rem; */
}
.tab-pane-content-text .news-meta {
  margin-top: 1.5rem;
}

.swiper{
  background-color: #f9f9f9;
  padding: 2rem 4rem;
}
.swiper-container {
  margin: 0 auto;
  margin-top: 7rem;
  width: 84% !important;
  position: relative;
  height: 400px !important;
  /* background-color: #f9f9f9; */
  border-radius: 10px;
}

.swiper-slide {
  display: flex;
  align-items: center;
  gap: 3rem;
}

.left-text {
  flex: 1;
  /* padding: 0 3rem; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.responsive-img1{
  width: 100%;
  height: auto;
  display: block;
}
.responsive-img {
  width: 660px;
  height: 370px;
  border-radius: 10px;
  flex: 1;
  /* height: auto; */
  object-fit: cover;
}

.section1 {
  padding: 0 10rem 5rem 10rem;
  /* background-color: #f7f7f7; */
}
.section-title {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 5rem;
  font-weight: 500;
}

.swiper-container {
  width: 100%;
  height: 400px;
}

.swiper-button-next,
.swiper-button-prev {
  color: #fff;
  position: absolute;
  top: 100%;
  transform: translateY(-50%);
  z-index: 10;
  cursor: pointer;
  background: #14419e;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  font-size: 10px;
  /* transition: background 0.3s; */
}
/* 缩小箭头图标 */
::v-deep(.swiper-button-prev svg),
::v-deep(.swiper-button-next svg) {
  width: 25%;
}
.swiper-button-next:active,
.swiper-button-prev:active {
  background: #e60013;
}
.swiper-button-next {
  left: 8%;
}
.swiper-button-prev {
  left: 4%;
}

/* 新闻标题自动换行 */
.news-title {
  font-size: 1.8rem;
  white-space: pre-line;
  font-weight: 500;
  margin-bottom: 1.5rem;
}
.left-text p {
  font-size: 1.2rem;
  line-height: 1.5;
  margin-bottom: 2rem;
  color: #666;
}

/* 新闻元信息并列 */
.news-meta {
  display: flex;
  gap: 1rem;
  color: #666;
}

/* 标签导航 */
.tab-nav {
  display: flex;
  justify-content: center;
  gap: 9rem;
  margin-top: 4rem;
}
.tab-item {
  position: relative;
  padding: 0.5rem 1rem;
  cursor: pointer;
  font-size: 1.1rem;
  color: #333;
  transition: color 0.3s;
}
.tab-item.active {
  color: #e60013;
}
.tab-item.active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 100%;
  height: 2px;
  background: #e60013;
}

/* 内容区域 */
.tab-content {
  margin-top: 2rem;
  padding: 0 5rem;
}
.tab-pane {
    display: flex;
    /* justify-content: center; */
    gap: 2rem;
    flex-wrap: wrap;
  min-height: 200px;
  /* background: #fafafa; */
  border-radius: 8px;
  /* padding: 2rem; */
  font-size: 1rem;
  color: #666;
}
/* 展示更多按钮 */
.show-more {
  width: 100%;
  text-align: center;
  margin-top: 2rem;
  padding: 0.8rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 1.1rem;
}
.show-more:hover {
  color: #e60013;
}

.tab-pane-content:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24,144,255,.35);
  background-color: #f9f9f9;
}
.tab-pane-content:hover h3 {
  color: #1890ff;
}
::v-deep(.date-icon) {
  width: 1rem;
  height: 1rem;
  object-fit: contain;
  margin-right: 5px;
}

/* ========== 移动端适配 ========== */
@media (max-width: 1750px) {
  .swiper-button-next,
.swiper-button-prev {
  top: 105%;

}
}
@media (max-width: 768px) {
  ::v-deep(.date-icon) {
      width: 0.9rem !important;
      height: 0.9rem !important;
    }
  .swiper{
    padding: 2rem 1rem;
}
.swiper-slide {
    gap: 0rem;
}
  /* 整体间距缩小 */
  .section1 {
    padding: 2rem 1rem;
  }

  /* 轮播容器自适应 */
  .swiper-container {
    width: 100% !important;
    height: auto !important;
    margin-top: 2rem;
  }
  .swiper-slide {
    flex-direction: column;
    text-align: left;

  }
  .left-text {
    padding: 1rem;
  }
  .news-title {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }
  .left-text p {
    font-size: 1rem;
    margin-bottom: 0rem;
    min-height: 90px;
  }
  .responsive-img {
    width: 100%;
    height: auto;
  }

  /* 轮播箭头缩小并移到内部 */
  .swiper-button-next,
  .swiper-button-prev {
    display: none;
    top: 50%;
    transform: translateY(-50%) scale(0.8);
    width: 32px;
    height: 32px;
  }
  .swiper-button-prev {
    left: 10px;
  }
  .swiper-button-next {
    left: auto;
    right: 10px;
  }

  /* 标签导航横向滚动 */
  .tab-nav {
    gap: 2rem;
    /* overflow-x: auto;
    justify-content: flex-start; */
    /* padding: 0 1rem; */
  }
  .tab-item {
    flex-shrink: 0;
  }

  /* 新闻卡片一列显示 */
  .tab-content {
    padding: 0 1rem;
    
  }
  .tab-pane {
    flex-direction: column;
    align-items: center;
  }
  .tab-pane-content {
    width: 100%;
    margin-bottom: 1.5rem;
  }
  .tab-pane-content-text {
    height: auto;
    margin-top: 1rem;
  }
  .tab-pane-content-text h3 {
    margin-bottom: 1rem;
    font-size: 1.1rem;
  }
  .news-meta {
    margin-top: 1rem;
    font-size: 0.9rem;
  }
  .tab-pane-content {
    padding: 0;
}
  .tab-pane-content img {
    width: 100%;
    height: auto;
    /* border-radius: 15px; */
}
  /* 加载更多按钮 */
  .show-more {
    margin-top: 1.5rem;
    padding: 0.6rem;
    font-size: 1rem;
  }
}

/* 更小屏幕微调 */
@media (max-width: 480px) {
  ::v-deep(.date-icon) {
      width: 0.81rem;
      height: 0.81rem;
    }
  .news-title {
    font-size: 1.1rem;
  }
  .left-text p {
    font-size: 0.9rem;
  }
  .tab-item {
    font-size: 1rem;
  }
}
</style>